// extracted by mini-css-extract-plugin
export default {"container":"up-z","heading":"vp-z","text":"wp-z","info":"xp-z","link":"yp-z","fullMaxWidth":"zp-z"};